<template>
  <div>
    <section id="hero-home" class="hero has-text-centered is-dark hero-emphasis">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
          <div class="column feature-text">
            <h1 class="title has-text-white is-size-1">Connecting Research to Industry.<br>
            </h1>
            <h2 class="subtitle is-size-5 has-text-white">
              Leading-Edge Digital Research Collaboration
            </h2>
            <br/>
            <router-link class="button is-primary" to="/contact">
              Connect with us
            </router-link>
          </div>
        </div>
        </div>
      </div>
    </section>
    <div id="our-model"></div>
    <section class="columns has-background-light feature">
          <div class="column feature-body is-full-mobile">
            <div class="copy-left">
              <h1 class="title">Our Model</h1>
              <h2
                class="subtitle"
              >An innovative approach to connect industry with research partners to develop solutions to the world's most pressing challenges.</h2>
            </div>
          </div>
          <div class="column is-two-fifths-tablet feature-image"><img src="/img/ModelImage.svg" alt=""></div>
    </section>
    <div id="our-network"></div>
    <section class="columns has-background-dark has-text-right feature">
          <div class="column is-two-fifths-tablet feature-image"><img src="/img/NetworkImage.svg" alt=""></div>
          <div class="column feature-body">
            <div class="column is-offset-3">
              <div class="copy-right">
                <h1 class="title has-text-white">Our Network</h1>
                <h2 class="subtitle has-text-white">A global network to leverage talented researchers and <span class="no-break">state-of-the-art</span> facilities to drive data-driven decisions.</h2>
              </div>
            </div>
          </div>
    </section>
    <div id="our-platform"></div>
    <section class="columns has-background-light feature">
          <div class="column feature-body">
            <div class="copy-left">
              <h1 class="title">Our Platform</h1>
              <h2
                class="subtitle"
              >Encrypted communications to facilitate secure collaboration driving high quality, sustainable industry research outcomes.</h2>
            </div>
          </div>
          <div class="column is-two-fifths-tablet feature-image"><img src="/img/PlatformImage.svg" alt=""></div>
    </section>
  </div>
</template>

<style type="text/css">
@import "../styles/animation.scss";

#hero-home {
  position: relative;
}

#hero-home:after {
  content: "\A";
  background-image: url("/img/banner-office.jpg");
  background-size: cover;
  background-position-y: center;
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: darken;
  height: 100%;
  width: 100%;
  position: absolute;
}

.hero-body {
  z-index: 1;
}

#hero-image {
  background: none;
  width: 100%;
  height: 100%;
}
#hero-container {
  width: 50%;
  height: 100%;
  position: absolute;
  right: 0;
}
#hero-home {
  position: relative;
}
.title {
  padding-bottom: 1rem;
}
.hero-body {
  background: url("/img/feature-manufacturing.jpg");
  background-size: cover;
  background-position-y: center;
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: darken;
}
.feature-body {
  display: flex;
  align-items: center;
  padding: 4rem;
}
svg {
  height: 100%;
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.button {
  font-weight: 600;
}
.feature-image {
  display: none;
}
.copy-left,
.copy-right {
  max-width: 48rem;
}
.no-break {
  white-space: nowrap;
}
@media screen and (min-width: 769px) {
  #our-model,
  #our-platform,
  #our-network {
    margin-top: calc(-1 * var(--navbar-height));
    padding-top: calc(var(--navbar-height) * 1);
    border-bottom: 3px solid black;
  }
  .feature {
    height: 28rem;
  }
  .feature-body {
    display: flex;
    align-items: center;
    padding: 5em;
  }
  .feature img {
    display: block;
  }
  .feature-text {
    padding-top: 9rem;
    padding-bottom: 9rem;
  }
  .feature-image {
    display: flex;
  }
}
@media screen and (min-width: 900px) {
  #hero-image {
    background-size: cover;
    background-position: center;
  }
}
@media screen and (min-width: 1440px) {
  .copy-left {
    padding-left: 8rem;
  }
  .copy-right {
    padding-right: 8rem;
  }
}
</style>

<script>
// import Model from "/img/ModelImage.svg";
// import Network from "@/components/svg/NetworkImage.vue";
// import Platform from "@/components/svg/PlatformImage.vue";

export default {
  name: "home",
  components: {
    // Model
    // Network,
    // Platform
  }
};
</script>
